// extracted by mini-css-extract-plugin
module.exports = {"recalculateBox":"styles_recalculateBox__2Z5DP"};